import { Human } from "../Models/Human";
import { Order } from "../Models/Order";
import { Ticket } from "../Models/Ticket";
import { StepFactory } from "./StepFactory";
import { StepsPlanner } from "./StepsPlanner";


export class TicketToOrderConverter
{
    constructor(private _factory: StepFactory)
    { }

    public Convert(ticket: Ticket, btcValueInPln?: number): Order
    {
        try
        {
            const steps = new StepsPlanner(this._factory, btcValueInPln).Plan(ticket);

            const order = new Order();
            order.Id = ticket.Id.toUpperCase();
            order.People.Add(new Human(ticket.Customer));
            order.Steps.Load(...steps);
            order.Meta.CreatedAt = ticket.Meta.CreatedAt;
            order.Meta.CreatedBy = ticket.Meta.CreatedBy;
            order.Meta.Ticket = ticket;

            return order;
        }
        catch (e)
        {
            console.error(`Ticket ${ticket.Id} to Order conversion failed:`, e);
            throw e;
        }
    }
}
